import { Link } from 'react-router-dom';
import { FaArrowRight, FaPlayCircle } from 'react-icons/fa';

const ApplicationInstructions = () => {
    // Hardcoded YouTube video URL - replace with your actual video URL
    // You can use either:
    // - Full URL: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
    // - Short URL: "https://youtu.be/dQw4w9WgXcQ"
    // - Just the video ID: "dQw4w9WgXcQ"
    const youtubeVideoUrl = 'https://youtu.be/5uky-VPxGV0'; // Replace with your actual YouTube video ID or URL
    
    // Extract video ID from YouTube URL
    const getVideoId = (url) => {
        if (!url) return 'dQw4w9WgXcQ'; // Default fallback
        
        // If it's already just an ID (11 characters, alphanumeric)
        if (/^[a-zA-Z0-9_-]{11}$/.test(url)) {
            return url;
        }
        
        // Extract from various YouTube URL formats
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url.match(regExp);
        return (match && match[2] && match[2].length === 11) ? match[2] : 'dQw4w9WgXcQ';
    };

    const videoId = getVideoId(youtubeVideoUrl);
    const embedUrl = `https://www.youtube.com/embed/${videoId}`;

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-50 py-12 px-4">
            <div className="max-w-4xl mx-auto">
                {/* Header */}
                <div className="text-center mb-8">
                    <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
                        Scholarship Application Instructions
                    </h1>
                    <p className="text-lg text-gray-600">
                        Watch the video below to learn how to fill out your scholarship application form
                    </p>
                </div>

                {/* Video Section */}
                <div className="bg-white rounded-xl shadow-2xl p-6 md:p-8 mb-8">
                    <div className="aspect-video w-full rounded-lg overflow-hidden bg-gray-900">
                        <iframe
                            src={embedUrl}
                            title="Scholarship Application Instructions"
                            className="w-full h-full"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    </div>
                    
                    {/* Video Info */}
                    <div className="mt-6 text-center">
                        <h2 className="text-2xl font-semibold text-gray-900 mb-2">
                            Step-by-Step Application Guide
                        </h2>
                        <p className="text-gray-600">
                            Follow along with the video to ensure you complete all required fields correctly
                        </p>
                    </div>
                </div>

                {/* Important Information */}
                <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-lg mb-8">
                    <h3 className="font-semibold text-yellow-900 mb-2">Before You Begin:</h3>
                    <ul className="list-disc list-inside text-yellow-800 space-y-2">
                        <li>Have your personal information ready (name, email, contact number)</li>
                        <li>Photo ready for educational certificates and government ID</li>
                        <li>Have a passport-sized photo ready for upload</li>
                        <li>Ensure you have a stable internet connection</li>
                        <li>Set aside 15-20 minutes to complete the application</li>
                    </ul>
                </div>

                {/* Continue Button */}
                <div className="text-center">
                    <Link
                        to="/apply-public"
                        className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-gradient-to-r from-blue-600 to-blue-700 text-white text-lg font-bold rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200"
                    >
                        <FaPlayCircle className="text-xl" />
                        Continue to Application Form
                        <FaArrowRight />
                    </Link>
                    <p className="mt-4 text-sm text-gray-500">
                        You can always come back to watch this video if needed
                    </p>
                </div>

                {/* Back to Home */}
                <div className="text-center mt-8">
                    <Link
                        to="/"
                        className="text-blue-600 hover:text-blue-700 font-medium"
                    >
                        ← Back to Home
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default ApplicationInstructions;
